interface IconProps {
  color?: string
}

export const ClearAllIcon: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 13H19V11H5V13ZM3 17H17V15H3V17ZM7 7V9H21V7H7Z" fill={color} />
  </svg>
)
